module.exports = __webpack_public_path__ + "static/media/Nicole.dcf4ed4b.png";